export const 
	CONFIG_ACKNOWLEDGE			= 'CONFIG_ACKNOWLEDGE'